import { useController } from 'react-hook-form';

import ErrorMessage from '@/components/ErrorMessage';
import { RadioGroup, RadioGroupItem } from '@/components/RadioGroup';
import { cn } from '@/utils';

import Label from './Label';
import { parseMessage } from './utils';

function FormRadio({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	defaultValue,
	options,
	labelClassName,
	className,
	groupClassName,
	itemLabelClassName,
	...props
}) {
	const { field, fieldState } = useController({ name, control, disabled });

	return (
		<div className={cn('form-input relative w-full', className)}>
			{label && (
				<Label
					className={cn('mb-[14px] whitespace-nowrap', labelClassName)}
					htmlFor={id}
				>{`${label}${required ? '*' : ''}`}</Label>
			)}
			<RadioGroup
				error={fieldState.invalid}
				defaultValue={field.value}
				className={groupClassName}
				onValueChange={field.onChange}
				{...field}
				{...props}
			>
				{options.map(option => {
					return (
						<div
							className="flex items-center space-x-2 whitespace-nowrap"
							key={name + option.value}
						>
							<RadioGroupItem
								value={option.value}
								id={option.value}
								checked={field.value === option.value}
							/>
							<Label
								className={cn(
									'mb-0 w-full cursor-pointer whitespace-nowrap text-xs font-normal leading-tight text-grey-500',
									itemLabelClassName
								)}
								htmlFor={option.value}
							>
								{option.label}
							</Label>
						</div>
					);
				})}
			</RadioGroup>
			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{parseMessage(fieldState.error.message)}
				</ErrorMessage>
			)}
		</div>
	);
}

export default FormRadio;
